// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3vGdb","content":"Consent_content__5tGhk","footer":"Consent_footer__3uOAX"};